import { FunctionComponent } from 'react';
import { Avatar, Tooltip, styled } from '@mui/material';
import { AuthUser } from '@/core/types';
import SideNavigationItem from './SideNavigationItem';
import { useNavigate } from 'react-router-dom';

const TopDividerSideNavigationItem = styled(SideNavigationItem)({
	borderWidth: 0,
	borderStyle: 'solid',
	borderColor: 'rgba(0, 0, 0, 0.12)',
	borderTopWidth: 'thin',
});

const UserInfo: FunctionComponent<{ user: AuthUser }> = ({ user }) => {
	let navigate = useNavigate();

	return (
		<Tooltip
			arrow
			placement="right"
			title={
				<span>
					Logged in as{' '}
					<strong>
						{user.firstName} {user.lastName}
					</strong>
				</span>
			}
		>
			<TopDividerSideNavigationItem
				itemTitle={user.firstName}
				onClick={() => {
					navigate('/account');
				}}
				icon={
					<Avatar variant="rounded" sx={{ width: 32, height: 32 }}>
						{user.firstName.charAt(0)}
					</Avatar>
				}
			/>
		</Tooltip>
	);
};

export default UserInfo;
